export default "__VITE_ASSET__lMxp6I7q__"